import Amount from './common/Amount.svelte';

export default {
    Amount: Amount
};
